/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleDownIcon64Regular = forwardRef('ArrowFigureACircleDownIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M32 17.5a1.5 1.5 0 0 1 1.5 1.5v23.104l7.94-7.94a1.5 1.5 0 0 1 2.12 2.122l-8.378 8.378a4.5 4.5 0 0 1-6.364 0l-8.379-8.378a1.5 1.5 0 0 1 2.122-2.122l7.939 7.94V19a1.5 1.5 0 0 1 1.5-1.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32 6c14.36 0 26 11.64 26 26S46.36 58 32 58 6 46.36 6 32 17.64 6 32 6Zm23 26C55 19.297 44.703 9 32 9S9 19.297 9 32s10.297 23 23 23 23-10.297 23-23Z" })));
});
